import { create } from 'zustand';
import type { BuildSyncRow } from 'common/core/BuildSyncDocuments';
import type { CoreDocument } from 'common/core/CoreDocument';
import type { ClientDeploymentDocument, ClientDeploymentProjectDocument } from 'common/deployment/ClientDeploymentDocument';
import type { EditAppState } from 'client/lib/EditApp';

export interface DeploymentClientState extends EditAppState<ClientDeploymentDocument> {
  project: ClientDeploymentProjectDocument | null;
  activeDeploymentNames: string[];
  activeDeploymentLabels: string[];
  builds: BuildSyncRow[] | null;
  core: (Pick<CoreDocument, 'id' | 'coreStateID' | 'name' | 'domainName'> & { accountIdentifier: string }) | null;
  flags: any; // TODO: WHAT IS THIS ? LoadDeploymentResponse['flags'];
}

const initialState: DeploymentClientState = {
  document: null,
  project: null,
  activeDeploymentNames: [],
  activeDeploymentLabels: [],
  builds: null,
  core: null,
  flags: { isTrialOnboardingOpen: false },
};

export const useDeploymentClientState = create<DeploymentClientState>(() => initialState);
